import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { AlertCircle } from 'lucide-react';

export type EfErrorMessageProps = {
    id: string;
    content: string;
    errorLabel: string;
    errorTitleLabel: string;
    isUser: boolean;
};

export function EfErrorMessage({ id, content, errorLabel, errorTitleLabel, isUser }: EfErrorMessageProps) {
    return (
        <Box
            data-testid={`ef-chat-message-${id}`}
            sx={{
                alignSelf: isUser ? 'flex-end' : 'flex-start',
                maxWidth: '85%',
                px: 2,
                py: 1.25,
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'error.light',
                bgcolor: 'error.main',
                color: 'error.contrastText'
            }}
        >
            <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mb: 0.5 }}>
                <AlertCircle size={16} data-testid={`ef-chat-error-icon-${id}`} />
                <Typography sx={{ fontSize: 13, fontWeight: 600 }}>{errorTitleLabel}</Typography>
            </Stack>
            <Typography sx={{ fontSize: 14 }}>{content || errorLabel}</Typography>
        </Box>
    );
}
